import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row border-top border-bottom mt-3 no-gutters" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-danger badge-no rounded-circle" }, "5", -1)

import TheSidebarUserControl from "./TheSidebarUserControl.vue";
import FeatherIcon from "./FeatherIcon.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

const controls = [
        {
          text: "Notifications",
          iconName: "bell",
          onClick: () => "",
        },
        {
          text: "Settings",
          iconName: "settings",
          onClick: () => router.push('/app/settings'),
        },
        {
          text: "Logout",
          iconName: "log-out",
          onClick: () => store.dispatch("user/logout"),
        },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(controls, (control) => {
      return _createVNode(TheSidebarUserControl, _mergeProps({
        key: control.text
      }, { ...control }), {
        default: _withCtx(() => [
          _createVNode(FeatherIcon, {
            name: control.iconName,
            class: "svg-icon op-7"
          }, null, 8, ["name"])
        ]),
        notifications: _withCtx(() => [
          _createVNode(FeatherIcon, {
            name: control.iconName,
            class: "svg-icon op-7"
          }, null, 8, ["name"]),
          _hoisted_2
        ]),
        _: 2
      }, 1040)
    }), 64))
  ]))
}
}

})